import { render } from "./DeviationDelayTable.vue?vue&type=template&id=47374a98"
import script from "./DeviationDelayTable.vue?vue&type=script&lang=ts"
export * from "./DeviationDelayTable.vue?vue&type=script&lang=ts"
script.render = render

export default script